export const debug: boolean = false

export const clientId: string = debug ? '1076685492172636211' : '842425623754702868'

export const apiUrl: string = debug ? 'http://localhost:3001' : 'https://api.niako.life'

export const loginUrl: string = `https://discord.com/api/oauth2/authorize?client_id=${clientId}&redirect_uri=${window.location.origin}/callback&response_type=code&scope=identify%20guilds`